import { useQuery } from '@tanstack/react-query';
import { useNavigation } from '@/contexts/NavigationContext';
import { supportAssistantService } from '@/services/support-assistant.service';

/**
 * Access is derived from server-gated navigation (node uid 'support-assistant',
 * module SUPPORT_ASSISTANT) plus the status endpoint (kill switch / env / location).
 */
export function useAssistantAccess(locationId?: string) {
  const { sections, loading, error } = useNavigation();
  const hasAccess = sections.some((s) =>
    s.nodes?.some((n) => n.uid === 'support-assistant'),
  );

  const status = useQuery({
    queryKey: ['assistant-status', locationId],
    queryFn: () => supportAssistantService.getStatus(locationId),
    enabled: hasAccess,
  });

  return {
    hasAccess,
    enabled: hasAccess && (status.data?.enabled ?? false),
    reason: status.data?.reason,
    killSwitchActive: status.data?.killSwitchActive ?? false,
    canToggleKillSwitch: status.data?.canToggleKillSwitch ?? false,
    status: status.data,
    onboarding: {
      launchDate: status.data?.gopherLaunchDate ?? null,
      // Default true while loading so spotlight/firstRun never flash early.
      spotlightSeen: status.data?.gopherSpotlightSeen ?? true,
      firstRunDone: status.data?.gopherFirstRunDone ?? true,
    },
    loaded:
      !loading &&
      (sections.length > 0 || error !== null) &&
      (!hasAccess || !status.isLoading),
  };
}
